import { BrowserRouter } from 'react-router-dom';

import { AppProviders } from '@/providers/AppProviders';

import { AppRouter } from './AppRouter';
import { ErrorBoundary } from './ErrorBoundary';

/** Root component: error boundary + providers + router (docs/development/FrontendGuidelines.md §2.1). */
export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppProviders>
          <AppRouter />
        </AppProviders>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
